module.exports = __webpack_public_path__ + "img/yingyongspeed.62b61e58.png";